var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37546 11.2496C3.44934 11.2498 3.52252 11.2353 3.59077 11.207C3.65901 11.1787 3.72096 11.1371 3.77303 11.0847C3.99275 10.8649 3.99275 10.5086 3.77303 10.2889L1.35801 7.87405L3.77303 5.45907C3.99275 5.23935 3.99275 4.88312 3.77303 4.6634C3.55317 4.44354 3.19694 4.44354 2.97722 4.6634L0.164807 7.47581C-0.0549123 7.69553 -0.0549123 8.05176 0.164807 8.27148L2.97722 11.0839C3.02931 11.1365 3.09133 11.1783 3.1597 11.2067C3.22807 11.2352 3.30141 11.2498 3.37546 11.2496ZM12.0001 17.9994C12.1607 17.9994 12.313 17.9769 12.4651 17.9297L16.9786 16.426C17.5927 16.2114 18 15.6392 18 14.9996V1.5C18 0.672764 17.3272 0 16.5 0C16.3396 0 16.1873 0.0224993 16.035 0.0697478L11.5217 1.57347C10.9074 1.78796 10.5003 2.36021 10.5003 2.99986V16.4994C10.5003 17.3267 11.1729 17.9994 12.0001 17.9994ZM16.5 1.12496C16.7063 1.12496 16.875 1.29371 16.875 1.5V14.9996C16.875 15.1593 16.7678 15.3077 16.6148 15.361L12.1225 16.858C12.0902 16.8684 12.0482 16.8745 12.0001 16.8745C11.7939 16.8745 11.6252 16.7057 11.6252 16.4994V2.99986C11.6252 2.84015 11.7325 2.69169 11.8855 2.63843L16.3778 1.14145C16.41 1.13101 16.4521 1.12496 16.5 1.12496Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e1df50fb015135249675dc2383f734b2.svg";
export { ForwardRef as ReactComponent };